import { icons } from '@ublend-npm/aulaui-next';
import React from 'react';
import { Transforms } from 'slate';
import {
  ReactEditor,
  useSlateStatic,
  useSelected,
  useReadOnly,
} from 'slate-react';
import { UnsupportedElement } from '../../plugins/unsupported/UnsupportedElement';
import {
  Container,
  Button,
  Description,
  DescriptionWrapper,
} from './Unsupported.styled';

export type UnsupportedProps = {
  element: UnsupportedElement;
};

export const Unsupported = ({ element }: UnsupportedProps) => {
  const editor = useSlateStatic();
  const isReadOnly = useReadOnly();
  const isSelected = useSelected();
  const at = ReactEditor.findPath(editor, element);

  const handleDeleteBlock = () => Transforms.removeNodes(editor, { at });

  return (
    <Container isSelected={isSelected}>
      <icons.WarningIcon />
      <DescriptionWrapper>
        <Description>
          Unsupported block type
          {isReadOnly ? null : (
            <>
              <br />
              <Button onClick={handleDeleteBlock}>Delete block</Button>
            </>
          )}
        </Description>
      </DescriptionWrapper>
    </Container>
  );
};
